import React from 'react';

import { useIntlDictionary } from 'hooks/useIntlDictionary';
import {
  TableTr,
  TableWrapper,
  TableHead,
  TableTh,
  TableBody,
} from 'design/table';
import {
  PartnerClientsTableItem,
  PartnerClientsTableSortableField,
} from 'types/partnerClientsTable';
import { PartnerCancelledClientsTableRow } from 'containers/PartnerClientsTable/PartnerCancelledClientsTableRow';
import { HoverableTooltipComponent } from 'design/hoverableTooltip/hoverableTooltipComponents';
import { UnderlinedTextComponent } from 'design/underlinedText/underlinedTextComponents';

type Props = {
  items: PartnerClientsTableItem[];
  sortedBy: PartnerClientsTableSortableField;
  ascendingSort: boolean;
  activeItemId?: number;
  onSortChange(nextSortBy: PartnerClientsTableSortableField): void;
  onItemClick(item: PartnerClientsTableItem): void;
};

export const PartnerCancelledClientsTable = (props: Props) => {
  const { items, sortedBy, ascendingSort, activeItemId, onItemClick } = props;

  const {
    partnerClientsTable: ownDictionary,
    shared: sharedDictionary,
  } = useIntlDictionary();

  // Мемоизированные строки таблицы клиентов.
  const tableRowsNode = React.useMemo(() => {
    return items.map((item) => (
      <PartnerCancelledClientsTableRow
        key={item.id}
        active={activeItemId === item.id}
        item={item}
        onClick={onItemClick}
      />
    ));
  }, [items, activeItemId, onItemClick]);

  return (
    <TableWrapper>
      <TableHead>
        <TableTr>
          <TableTh
            size="m"
            sorted={sortedBy === 'organization'}
            ascending={ascendingSort}
            text={ownDictionary.organizationLabel}
          />
          <TableTh
            size="auto"
            sorted={sortedBy === 'firstName'}
            ascending={ascendingSort}
            text={ownDictionary.contactFullNameLabel}
          />
          <TableTh
            size="m"
            sorted={sortedBy === 'position'}
            ascending={ascendingSort}
            text={ownDictionary.positionLabel}
          />
          <TableTh
            size="l"
            sorted={sortedBy === 'phone'}
            ascending={ascendingSort}
            text={ownDictionary.phoneLabel}
          />
          <TableTh
            size="s"
            sorted={sortedBy === 'orgSize'}
            ascending={ascendingSort}
            text={ownDictionary.orgSizeLabel}
          />
          <TableTh
            size="m"
            sorted={sortedBy === 'licensesCount'}
            ascending={ascendingSort}
            text={
              <HoverableTooltipComponent
                text={sharedDictionary.licensesTooltipText}
              >
                <UnderlinedTextComponent>
                  {ownDictionary.licensesCountLabel}
                </UnderlinedTextComponent>
              </HoverableTooltipComponent>
            }
          />
          <TableTh
            size="l"
            sorted={sortedBy === 'subscription'}
            ascending={ascendingSort}
            text={ownDictionary.subscribtionStatusLabel}
          />
          <TableTh
            size="l"
            sorted={sortedBy === 'willBeDeletedInDays'}
            ascending={ascendingSort}
            text={ownDictionary.willBeDeletedInDaysLabel}
          />
        </TableTr>
      </TableHead>
      <TableBody>{tableRowsNode}</TableBody>
    </TableWrapper>
  );
};
